import { Injectable } from '@angular/core';
import { UiOverlayService } from '@cynteka/ui-kit';

@Injectable({ providedIn: 'root' })
export class AiChatAlertService {
    public constructor(private readonly overlayService: UiOverlayService) {}

    /** Показывает информационную модалку с одной кнопкой «ОК». */
    public show(message: string, title = 'Внимание'): void {
        const modal = this.overlayService.createModalOverlay({
            size: 'small',
            title,
            description: message,
            closeOnBackdrop: true,
            showCloseButton: true,
            actionButtons: [
                {
                    label: 'ОК',
                    color: 'primary-accent',
                    size: 'large',
                    callback: () => modal.close(),
                },
            ],
        });

        modal.open();
    }
}
